import type { ReactNode } from 'react'
import React from 'react'

import * as S from './EmptyState.styled'

type EmptyStateProps = {
  title: string
  subtitle: ReactNode
  children?: ReactNode
}

export const EmptyState = ({ title, subtitle, children }: EmptyStateProps) => {
  return (
    <S.Container>
      <S.InnerContainer>
        <S.TopContainer>
          <S.Title>{title}</S.Title>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.TopContainer>
        {children}
      </S.InnerContainer>
    </S.Container>
  )
}

export const Root = EmptyState
export const Recommendations = S.Recommendations
export const Suggestion = S.Suggestion
